import { getMockDataByKeys } from "./mock";

export const NOTIFY = {
  name: "notify",
  uuid: 0x6801,
  properties: ["read", "write", "notify"],
};
export function generateMockAWSNofifyData(): DomianControl.AWSNotifyData {
  const data = getMockDataByKeys(
    [
      // 实际横摆速度
      "UIRx_ACUYawRate",
      // 后轮角度
      "UIRx_AxleStAng_FA",
      // 方向盘角度
      "UIRx_AxleStAng_RA",
      // 前轮转向比
      "UIRx_FrontGearRto",
      // 原始横摆速度
      "UIRx_OrgYawRate",
      // 后轮转向比
      "UIRx_RearGearRto",
      // 方向盘角度
      "UIRx_SBW_HWAAng",
      // 车速
      "UIRx_VehSpd",
      "UIRx_AWSFrontAngAdd",
    ]
  );
  return data;
}
